/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Semantic icon registry: one CONCEPT, one glyph. Surfaces import a concept name, never
 * a glyph, so none can invent a second icon for something the app already draws.
 * Aliases, not wrappers — size, colour, aria-hidden and refs pass straight through.
 */

import {
  IconBarbell,
  IconBook,
  IconCheck,
  IconDoor,
  IconDotsVertical,
  IconId,
  IconInfoCircle,
  IconLock,
  IconPencil,
  IconPlayerPlayFilled,
  IconRepeat,
  IconTrash,
  IconTrophy,
  IconUser,
} from "@tabler/icons-react";

/** Whoever is running a class. Deliberately not MemberIcon's person: a coach and a
 *  member must not draw the same mark. Illegible below 12px, so the template chip
 *  carries no icon rather than a smudge. */
export const CoachIcon = IconId;

/** One member, or the signed-in user's own account. A group of them is IconUsers. */
export const MemberIcon = IconUser;

/** The People tab's roster of the gym's humans. Its own name, not CoachIcon, so it does
 *  not follow a future change to the coach glyph — it lists members as well as staff. */
export const RosterIcon = IconId;

/** A room of the gym: Box.rooms everywhere it is named. */
export const RoomIcon = IconDoor;

/** A workout or the programming that holds it. */
export const WorkoutIcon = IconBarbell;

/** A class members cannot see or book. */
export const InternalIcon = IconLock;

/** A PT programme: visible only to its coach, the athlete and the gym's admins. */
export const PrivateIcon = IconLock;

/** A programme or page the viewer can open but not change. */
export const ReadOnlyIcon = IconBook;

/** Opens an explanation of how something on screen is worked out. */
export const InfoIcon = IconInfoCircle;

/** A result that is the athlete's actual performance: a tested max, time trial or unlock.
 *  Same glyph as WorkoutIcon, by design (F028 CP2-1). */
export const PerformanceKindIcon = IconBarbell;

/** A training result: a working set, whose number is an estimate. */
export const TrainingKindIcon = IconRepeat;

/** A related movement the athlete has tested: their own number, not an estimate. */
export const TestedIcon = IconCheck;

/** The athlete's PR: their best tested result ever. */
export const PrIcon = IconTrophy;

/** Opens the actions menu of one row in a list or table. */
export const RowActionsIcon = IconDotsVertical;

/** Changes something already saved. */
export const EditIcon = IconPencil;

/** Removes something the person saved. */
export const DeleteIcon = IconTrash;

/** Starts a video. */
export const PlayIcon = IconPlayerPlayFilled;
